import styled from 'styled-components';
import { Flex } from '../styles/Common.styled';

export const FlexFormStyle = styled('div')`
  ${Flex};
  width: 100%;
  flex-direction: column;
  gap: 4px;
  padding: 0px;
`;
